const modal = document.getElementById("contact-us-modal");
const contactButtons = document.querySelectorAll(
  "[data-action='contact-us-modal']",
);
contactButtons.forEach((button) => {
  button.addEventListener("click", () => {
    modal.showModal();
  });
});
